/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Temperature from './temperature';
import TemperatureDetail from './temperature-detail';
import TemperatureUpdate from './temperature-update';
import TemperatureDeleteDialog from './temperature-delete-dialog';

const TemperatureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Temperature />} />
    <Route path="new" element={<TemperatureUpdate />} />
    <Route path=":id">
      <Route index element={<TemperatureDetail />} />
      <Route path="edit" element={<TemperatureUpdate />} />
      <Route path="delete" element={<TemperatureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TemperatureRoutes;
